import { PaginationResponse } from "models/pagination-response";
import { IConvenioPagedRequest } from "models/request/convenio-paged-request";
import { IConvenioPagedResponse } from "models/response/convenio-paged-response";
import { ISituacaoConvenioResponse } from "models/response/situacao-convenio-response";
import { IConvenioTotaisResponse } from "models/response/convenio-totais-response";

export type ConveniosState = {
    convenios: PaginationResponse<IConvenioPagedResponse>;
    convenioPagedRequest: IConvenioPagedRequest;
    situacoes: ISituacaoConvenioResponse[];
    ultimaAtualizacao: string | null;
    totais: IConvenioTotaisResponse;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setConvenios = 'setConvenios',
    setConvenioPagedRequest = 'setConvenioPagedRequest',
    setSituacoes = 'setSituacoes',
    setUltimaAtualizacao = 'setUltimaAtualizacao',
    setTotais = 'setTotais',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const ConveniosReducer = (state: ConveniosState, action: any): ConveniosState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setConvenioPagedRequest:
            return { ...state, convenioPagedRequest: payload };
        case ACTION_TYPES.setConvenios:
            return { ...state, convenios: payload };
        case ACTION_TYPES.setSituacoes:
            return { ...state, situacoes: payload };
        case ACTION_TYPES.setUltimaAtualizacao:
            return { ...state, ultimaAtualizacao: payload };
        case ACTION_TYPES.setTotais:
            return { ...state, totais: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
